import {combineReducers} from "redux";

import ScrollModule from "../module/ScrollModule";

const RootReducer = combineReducers({
	ScrollModule
});

export default RootReducer;